import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <h2>Privacy Policy della Web App di Ristorante Duomila Ascoli</h2>
      <p><strong>Ultimo aggiornamento: 02/08/2025</strong></p>
      
      <p>
        La presente Privacy Policy descrive come vengono raccolti, utilizzati e trattati i dati personali 
        degli utenti che utilizzano la web app disponibile all'indirizzo https://duomila-app-ascoli.web.app per effettuare ordini.
      </p>

      <h3>1. Titolare del Trattamento dei Dati</h3>
      <p>
        Ristorante Duomila Ascoli SRL<br />
        Via Piceno Aprutina 37, Ascoli Piceno<br />
        P.IVA: 02549330443<br />
        Email di contatto per la privacy: duomilarestaurant@gmail.com
      </p>

      <h3>2. Dati Personali Raccolti</h3>
      <p>
        Raccogliamo i seguenti dati personali forniti volontariamente dall'utente al momento dell'ordine:
        <ul>
          <li><strong>Nome e Cognome:</strong> per identificare il cliente e l'ordine.</li>
          <li><strong>Numero di Telefono:</strong> per trasmettere l'ordine tramite il servizio di messaggistica istantanea WhatsApp e per eventuali comunicazioni urgenti relative all'ordine stesso.</li>
          <li><strong>Indirizzo di Consegna:</strong> solo se l'utente sceglie il servizio di consegna a domicilio.</li>
          <li><strong>Dettagli dell'Ordine:</strong> i prodotti scelti dall'utente.</li>
        </ul>
      </p>

      <h3>3. Finalità e Base Giuridica del Trattamento</h3>
      <p>
        I dati raccolti sono trattati esclusivamente per le seguenti finalità:
        <ul>
          <li>Gestire e processare l'ordine del cliente. La base giuridica di questo trattamento è la necessità di eseguire misure precontrattuali e contrattuali adottate su richiesta dell'utente (Art. 6, par. 1, lett. b GDPR).</li>
          <li>Trasmettere i dettagli dell'ordine al personale del ristorante tramite l'applicazione WhatsApp per la sua preparazione ed evasione.</li>
        </ul>
        Il conferimento dei dati è facoltativo, ma il mancato conferimento rende impossibile processare l'ordine tramite la web app.
      </p>
      
      <h3>4. Modalità del Trattamento e Destinatari dei Dati</h3>
      <p>
        I dati raccolti dalla web app vengono immediatamente inoltrati al numero WhatsApp aziendale di Ristorante Duomila Ascoli Srl e non vengono memorizzati sui server della web app.
        Il trattamento dei dati avviene tramite strumenti informatici. Una volta trasmessi, i dati sono presenti all'interno della piattaforma WhatsApp e sul dispositivo aziendale che riceve gli ordini. WhatsApp agisce come autonomo titolare del trattamento per quanto riguarda i servizi da esso erogati. Per maggiori informazioni, si prega di consultare la privacy policy di WhatsApp.
        Ristorante Duomila Ascoli Srl si impegna a non distribuire o comunicare i dati a terzi, ad eccezione di quanto strettamente necessario per l'adempimento dell'ordine (es. trasmissione a WhatsApp).
      </p>

      <h3>5. Periodo di Conservazione dei Dati</h3>
      <p>
        I dati personali presenti nelle chat di WhatsApp saranno conservati sul dispositivo aziendale per il tempo strettamente necessario all'evasione dell'ordine e per adempiere agli obblighi di legge, in particolare quelli fiscali e contabili, per i quali la legge prevede una conservazione di 10 anni. Successivamente, i dati saranno cancellati o resi anonimi.
      </p>

      <h3>6. Diritti dell'Interessato</h3>
      <p>
        L'utente ha il diritto, in qualsiasi momento, di chiedere l'accesso, la rettifica, la cancellazione o la limitazione del trattamento dei propri dati personali, oltre al diritto alla portabilità dei dati. Le richieste possono essere inviate all'indirizzo email del Titolare. L'utente ha inoltre il diritto di proporre reclamo all'Autorità di controllo (Garante per la Protezione dei Dati Personali).
      </p>
    </div>
  );
}

export default PrivacyPolicy;